import React from 'react';
import { Sparkles, X, CheckCircle2, AlertCircle } from 'lucide-react';
import { Progress } from '../../ui/progress';
import { Button } from '../../ui/button';

export const RegenerateJobBanner = ({ job, onDismiss }) => {
  if (!job) return null;
  const percent = job.total ? Math.round((job.completed / job.total) * 100) : 0;
  const running = job.status === 'running';
  const failed = job.results?.filter((r) => r.status === 'error') || [];
  const current = job.results?.[job.results.length - 1];

  return (
    <div
      data-testid="regenerate-job-banner"
      className="rounded-xl border border-amber-200 bg-amber-50/70 p-4 flex items-start gap-4"
    >
      <div className="mt-0.5">
        {running ? (
          <Sparkles className="w-5 h-5 text-amber-600 animate-pulse" />
        ) : failed.length ? (
          <AlertCircle className="w-5 h-5 text-orange-600" />
        ) : (
          <CheckCircle2 className="w-5 h-5 text-green-600" />
        )}
      </div>
      <div className="flex-1 min-w-0 space-y-2">
        <div className="flex items-center justify-between gap-3">
          <p className="text-sm font-medium text-neutral-800" data-testid="regenerate-job-status">
            {running
              ? `Generating AI visualizations… ${job.completed}/${job.total}`
              : `Regeneration complete — ${job.total - failed.length}/${job.total} succeeded`}
          </p>
          <span className="text-xs text-neutral-500 tabular-nums">{percent}%</span>
        </div>
        <Progress value={percent} className="h-2" />
        {running && current && (
          <p className="text-xs text-neutral-500 truncate">Last finished: {current.name}</p>
        )}
        {!running && failed.length > 0 && (
          <p className="text-xs text-orange-700 truncate">
            Failed: {failed.map((f) => f.name || f.color_id).join(', ')}
          </p>
        )}
      </div>
      {!running && (
        <Button variant="ghost" size="icon" onClick={onDismiss} data-testid="regenerate-job-dismiss">
          <X className="w-4 h-4" />
        </Button>
      )}
    </div>
  );
};

export default RegenerateJobBanner;
